import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Autoplay, Keyboard, Navigation, Pagination, Scrollbar, Mousewheel } from "swiper/modules";

export default class extends Controller {
    static values = {
        selector: String,
        modules: String,
        slidesperview: String,
        spacebetween: String,
        swiperconfig: String,
        clickcontrol: String
    };

    #sliderData = {};
    #moduleData = [];

    connect() {
        this.init();

        if (!this.isTouch() && this.clickcontrolValue == 'true') {
            this.setSlideOnClick();
        }
        if (window.debug) {
            console.log("Stimulus Controller found\n", 'selector: ' + this.selectorValue + "\n", this.clickcontrolValue, "sliderData:", this.#sliderData, "\n", 'isTouch?:', this.isTouch());
        }
    }

    init() {
        if (this.swiperconfigValue != '') {
            this.#sliderData = JSON.parse(this.swiperconfigValue);
        }

        if (this.modulesValue != '') {
            if (this.modulesValue.includes(',')) {
                this.modulesValue = this.modulesValue.replaceAll(' ', '');
                this.modulesValue = this.modulesValue.split(',');
            } else {
                this.modulesValue = [this.modulesValue];
            }
            this.#sliderData.modules = this.setModuleData(this.modulesValue);
        }

        if (this.selectorValue != undefined) {
            this.swiper = new Swiper(this.selectorValue, this.#sliderData);
        }
    }

    setModuleData(moduleValues) {
        if (moduleValues.includes('Navigation')) {
            this.#moduleData.push(Navigation);
        };
        if (moduleValues.includes('Keyboard')) {
            this.#moduleData.push(Keyboard);
        };
        if (moduleValues.includes('Pagination')) {
            this.#moduleData.push(Pagination);
        };
        if (moduleValues.includes('EffectCoverflow')) {
            this.#moduleData.push(EffectCoverflow);
        };
        if (moduleValues.includes('Scrollbar')) {
            this.#moduleData.push(Scrollbar);
        };
        if (moduleValues.includes('Mousewheel')) {
            this.#moduleData.push(Mousewheel);
        };
        if (moduleValues.includes('Autoplay')) {
            this.#moduleData.push(Autoplay);
        };
        return this.#moduleData;
    }

    setSlideOnClick() {
        let slides = this.element.querySelectorAll(this.selectorValue + ' .swiper-slide'),
            count = 0;
        slides.forEach(element => {
            element.setAttribute('data-index', count);
            element.addEventListener('click', click => {
                this.element.swiper.slideTo(element.getAttribute('data-index'));
            })
            count++;
        });
    }

    isTouch() {
        return 'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
    }
}